import {
  Breadcrumb,
  PageHeader,
  Table,
  Spin,
  message,
  Button,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import Page from "_components/Page";
import { Link } from "react-router-dom";
import { guranteeService } from "_services";
import { CurrencyFormatter } from "_helpers/formatters";
import moment from "moment";
function List({ match }) {
  const { path } = match;
  const [gurantees, setGurantees] = useState(null);
  const [loading, setLoading] = useState(false);

  const getActionButtons = () => {
    let buttons = [];

    buttons.push(
      <Link to={`${path}/add`} key="btn-add gurantee">
        <Button>Add</Button>
      </Link>
    );
    return buttons;
  };

  useEffect(() => {
    getAllGurantees();
  }, []);

  const getAllGurantees = () => {
    setLoading(true);
    guranteeService
      .getAll()
      .then((data) => {
        setGurantees(data.content);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        message.error(error);
      });
  };

  const columns = [
    {
      title: "Type",
      dataIndex: "guranteeType",
      key: "guranteeType",
      render: (text, record) => {
        const isExpired = moment().isAfter(moment(record.validTo));

        return isExpired ? (
          <Link to={`/gurantees/${record.id}/summary`}>{text}</Link>
        ) : (
          <span>{text}</span>
        );
      },
    },
    {
      title: "Currency",
      dataIndex: ["currency", "code"],
      key: "currencyCode",
    },
    {
      title: "Amount",
      dataIndex: "value",
      key: "value",
      render: (text, record) => CurrencyFormatter(text ?? 0),
    },
    {
      title: "Valid From",
      dataIndex: "validFrom",
      key: "validFrom",
    },
    {
      title: "Valid To",
      dataIndex: "validTo",
      key: "validTo",
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        let color = "";
        if (text === "ACTIVE") {
          color = "#87d068";
        }
        if (text === "OPEN") {
          color = "#2db7f5";
        }
        if (text === "UPDATE") {
          color = "#108ee9";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    },
  ];

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/gurantees">Gurantees</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={getActionButtons()}
    >
      <Page inner>
        <Spin spinning={loading}>
          <Table columns={columns} dataSource={gurantees} />
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default List;
